import React from 'react';
import { AnimatedSection } from '../components/ui/AnimatedSection';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { ArrowRightIcon } from 'lucide-react';
export function Programs() {
  const programs = [{
    title: 'Longevity Program',
    subtitle: '6-Month Metabolic Transformation',
    desc: 'Our flagship program designed to restore metabolic health, optimize performance, and extend healthspan through data-driven protocols.',
    image: 'https://images.unsplash.com/photo-1581009146145-b5ef050c2e1e?q=80&w=2070',
    link: '/programs/longevity',
    features: ['Advanced blood work analysis', 'Customized nutrition protocol', 'Strength programming', 'Continuous coaching']
  }, {
    title: 'Corporate Wellness',
    subtitle: 'Elevate Your Organization',
    desc: 'A comprehensive program for companies that want to improve employee health, productivity, and leadership culture.',
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070',
    link: '/programs/corporate-wellness',
    features: ['Metabolic health education', 'Team strength programs', 'Mindset workshops', 'Health ROI tracking']
  }, {
    title: 'Faith & Fitness Challenge',
    subtitle: '30-Day Body & Spirit Reset',
    desc: 'A transformation program designed for communities to restore the body as a temple and align health with biblical principles.',
    image: 'https://images.unsplash.com/photo-1447452001602-7090c7ab2db3?q=80&w=2070',
    link: '/programs/faith-fitness',
    features: ['Daily devotionals', 'Structured workouts', 'Community accountability', 'Spiritual growth']
  }];
  return <main className="w-full pt-24" data-id="element-920">
      <section className="py-20 md:py-32 bg-dark" data-id="element-921">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-922">
          <AnimatedSection data-id="element-923">
            <SectionHeading overline="Transformation Pathways" title="Our Programs" description="Choose the path that aligns with your current goals, whether you're an individual seeking total optimization or a leader elevating your team." data-id="element-924" />
          </AnimatedSection>

          <div className="mt-20 space-y-24" data-id="element-925">
            {programs.map((program, i) => <AnimatedSection key={i} delay={0.1} direction={i % 2 === 0 ? 'right' : 'left'} data-id="element-926">
                <div className={`flex flex-col ${i % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`} data-id="element-927">
                  <div className="w-full lg:w-1/2" data-id="element-928">
                    <div className="relative aspect-[4/3] overflow-hidden border border-border" data-id="element-929">
                      <img src={program.image} alt={program.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" data-id="element-930" />
                      <div className="absolute inset-0 bg-black/40" data-id="element-931"></div>
                    </div>
                  </div>

                  <div className="w-full lg:w-1/2 space-y-6" data-id="element-932">
                    <span className="text-gold font-medium tracking-widest uppercase text-sm" data-id="element-933">
                      {program.subtitle}
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold text-white font-heading" data-id="element-934">
                      {program.title}
                    </h2>
                    <p className="text-muted text-lg leading-relaxed" data-id="element-935">
                      {program.desc}
                    </p>

                    <ul className="space-y-3 pt-4" data-id="element-936">
                      {program.features.map((feature, idx) => <li key={idx} className="flex items-center text-white/80" data-id="element-937">
                          <div className="w-1.5 h-1.5 bg-gold rounded-full mr-3" data-id="element-938"></div>
                          {feature}
                        </li>)}
                    </ul>

                    <div className="pt-8" data-id="element-939">
                      <Button to={program.link} variant="secondary" className="group" data-id="element-940">
                        View Program Details{' '}
                        <ArrowRightIcon className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-941" />
                      </Button>
                    </div>
                  </div>
                </div>
              </AnimatedSection>)}
          </div>
        </div>
      </section>
    </main>;
}